<notification *ngIf="notification.active" [type]="notification.type">
    {{ notification.message }}
</notification>
<notification *ngIf="fallbackName" [type]="noBookingNotification.type">
    <div>{{noBookingNotification.message}}</div>
    <div>
        <btn [type]="refreshBtnType" [value]="labels.refresh" (onClick)="refresh()"></btn>
    </div>
</notification>

<div class="global">
    <div>
        <div class="details-hotel">
            <div *ngIf="showIcon" class="icon-column">
                <fa-icon [icon]="iconBed"></fa-icon>
            </div>

            <div class="hotel-informations information-column">
                <h2 *ngIf="property?.name">
                    <span>{{ (property | transformHotelName).name }}</span>
                    <rating *ngIf="rating !== undefined || booking.property[0].rating"
                            [max]="5" [rating]="rating || booking.property[0].rating.value"></rating>
                </h2>
                <h2 *ngIf="fallbackName">
                    <span>{{ fallbackName }}</span>
                </h2>

                <ng-container>
                    <address-component *ngIf="property?.address" [property]="property.address | transformAddress"
                                       displayInline="true"></address-component>

                    <ng-container *ngIf="property?.telephone">
                        <telephone *ngFor="let telephone of property.telephone" [telephone]="telephone"></telephone>
                    </ng-container>

                    <btn *ngIf="hasDetails"
                         type="actionLink"
                         classList="no-spacing {{classBtnList}}"
                         [label]="labels.moreDetails"
                         (click)="showDetails()"></btn>

                    <ng-container *ngIf="property?.site">|
                        <btn [label]="labels.webSite"
                             type="actionLink"
                             classList="no-spacing {{classBtnList}}"
                             (click)="openWebSite(property.site)"></btn>
                    </ng-container>
                </ng-container>

                <loader *ngIf="loader.active && !fallbackName" [message]="loader.message" [type]="loader.type"></loader>

            </div>

            <div class="hotel-cancellation information-column">
                <div class="inline">
                    <ng-container *permissionIf="permissions.SHARED_HOST_SHOW">
                        <h2>{{booking.host | hostAlias | async}}</h2>
                    </ng-container>

                    <references [code]="booking.code"
                                [link]="booking.site?.text"></references>
                </div>

                <div class="selling-link" *ngIf="sellingLink?.paragraph?.url">
                    <btn [label]="sellingLink.paragraph.title"
                         type="actionLink"
                         classList="no-spacing {{classBtnList}}"
                         [size]="btnSize.noSize"
                         (click)="openWebSite(sellingLink.paragraph.url)"></btn>
                </div>

                <div *ngIf="helpDesk" class="help-desk">
                    {{labels.helpDesk}}<span class="help-desk-number">{{helpDesk}}</span>
                </div>

                <meal-plan [name]="services?.mealplan?.name"
                           [code]="services?.mealplan?.mealplan?.xCode"></meal-plan>

                <cancellation-conditions class="cancellation"
                                         [keyword]="cancellationKeyword"
                                         [dateLastCancellationWithoutPenalty]="booking.whenLastToCancelWithoutPenalty"
                                         [penalty]="cancellationPenalties"
                                         [price]="cancellationBasePrice"></cancellation-conditions>

                <div *ngIf="canDisplayImportantInformationLink">
                    <btn [label]="labels.importantInformation"
                         icon="fa fa-exclamation-triangle"
                         type="actionLink"
                         classList="no-spacing {{classBtnList}}"
                         (click)="showImportantInformation()"></btn>
                </div>
            </div>

            <div class="hotel-price information-column">
                <ng-container *ngIf="quote && quote?.total; else bookingTotal">
                    <ng-container *ngIf="costTotal">
                        <span *ngIf="retailTotal">{{labels.costPrice}}</span>
                        <price-with-conversion [mainPrice]="costTotal.mainPrice" [originalPrice]="costTotal.asidePrice" type="big"></price-with-conversion>

                    </ng-container>
                    <ng-container *ngIf="retailTotal">
                        <span *ngIf="costTotal">{{labels.retailPrice}}</span>
                        <price-with-conversion [mainPrice]="retailTotal.mainPrice" [originalPrice]="retailTotal.asidePrice" type="big"></price-with-conversion>
                    </ng-container>
                </ng-container>
                <ng-template #bookingTotal>
                    <ng-container *ngIf="total">
                        <span *ngIf="totalRetail">{{labels.costPrice}}</span>
                        <price-with-conversion [mainPrice]="total" type="big"
                                               [originalPrice]="additionalTotal"></price-with-conversion>
                    </ng-container>
                    <ng-container *ngIf="totalRetail">
                        <span *ngIf="total">{{labels.retailPrice}}</span>
                        <price-with-conversion [mainPrice]="totalRetail" type="big"
                                               [originalPrice]="additionalTotalRetail"></price-with-conversion>
                    </ng-container>
                </ng-template>
                <ng-container>
                    <supplement-price *ngIf="totalLocal?.amount" [supplement]="totalLocal"></supplement-price>
                    <supplement-price *ngIf="!totalLocal?.amount && totalLocal?.originalCurrency?.amount" [supplement]="totalLocal.originalCurrency"></supplement-price>

                    <div class="pricePerRoom" *ngIf="quote">
                        <btn [label]="labels.pricePerRoom"
                             type="actionLink"
                             classList="no-spacing {{classBtnList}}"
                             (click)="showPricePerRoom()"></btn>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="accommodations && accommodations.length; else noRoomInSector">
            <div *ngFor="let accommodation of accommodations; let roomNumber = index;" class="travellers-informations">
                <div *ngIf="showIcon" class="icon-column">
                </div>
                <div class="information-column room-rooming">
                    <div class="room-informations information-sub-column">
                        <room-informations *ngIf="accommodation.room" [room]="accommodation.room"
                                           [roomNumber]="(roomNumber + 1)">
                        </room-informations>
                    </div>

                    <div class="room-traveller information-sub-column">
                        <ng-container *ngIf="accommodation.traveller | hasTravellersInfos; else travellerQuantity">
                            <sector-traveller *ngFor="let traveller of accommodation.traveller"
                                              [travellerData]="traveller"></sector-traveller>
                        </ng-container>

                        <ng-template #travellerQuantity>
                            <traveller-quantity [quantity]="accommodation.accommodation.quantity"></traveller-quantity>
                        </ng-template>
                    </div>
                </div>

                <div class="room-cancellation information-column">
                    <ng-container *ngIf="cancellationPenaltiesByAccomodationFromQuote; else showBookingPenalties">
                        <cancellation-conditions
                                [keyword]="cancellationKeyword"
                                [dateLastCancellationWithoutPenalty]="quote.dateLastCancellationWithoutPenalty"
                                [penalty]="cancellationPenaltiesByAccomodationFromQuote[accommodation.accommodation.xId]"
                                [price]="basePricesByAccomodation[accommodation.accommodation.xId]"></cancellation-conditions>
                    </ng-container>
                    <ng-template #showBookingPenalties>
                        <cancellation-conditions
                            [keyword]="cancellationKeyword"
                            [dateLastCancellationWithoutPenalty]="booking.whenLastToCancelWithoutPenalty"
                            [penalty]="cancellationPenaltiesByAccomodation[accommodation.accommodation.xId]"
                            [price]="basePricesByAccomodation[accommodation.accommodation.xId]"></cancellation-conditions>
                    </ng-template>
                </div>

                <div class="room-price information-column">
                    <ng-container *ngIf="showCostPrice">
                        <span *ngIf="accommodation.room?.retail?.length && showRetailPrice">{{labels.costPrice}}</span>
                        <price-with-conversion *ngIf="accommodation.room"
                                               [mainPrice]="accommodation.room"
                                               [originalPrice]="accommodation.room?.originalCurrency">
                        </price-with-conversion>
                    </ng-container>
                    <ng-container *ngIf="showRetailPrice">
                        <ng-container *ngFor="let retail of accommodation.room?.retail;">
                            <span *ngIf="showCostPrice && accommodation.room">{{labels.retailPrice}}</span>
                            <price-with-conversion [mainPrice]="retail"></price-with-conversion>
                        </ng-container>
                    </ng-container>

                    <ng-container>
                        <supplement-price *ngIf="accommodation.supplement?.value"
                                          [supplement]="accommodation.supplement"></supplement-price>
                        <supplement-price *ngIf="!accommodation.supplement?.value && accommodation.supplement?.originalCurrency"
                                          [supplement]="accommodation.supplement.originalCurrency"></supplement-price>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #noRoomInSector>
    <notification>{{ labels.noRoomDefined }}</notification>
</ng-template>

